import { Icon } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';
import * as React from 'react';

export const ButtonContentFilter = ({ active }: { active: boolean }) => {
	return (
		<div className="relative w-fit">
			<Icon
				src={Icons.filter}
				width={16}
				height={16}
				className="text-opacity-black"
			/>
			{active && (
				<span
					className={clsx(
						'bg-main-blue rounded-full w-[10px] h-[10px] absolute -right-2 -top-[0.1rem] border border-white',
						{
							hidden: false,
						}
					)}
				/>
			)}
		</div>
	);
};
